import React, { useCallback } from 'react';
import styles from './JumpToButton.module.scss';
import AnchorButton from '../Buttons/AnchorButton/AnchorButton';
import I18n from '../I18n/I18n/I18n';
export default function JumpToButton(_ref) {
  var children = _ref.children,
    _ref$hidden = _ref.hidden,
    hidden = _ref$hidden === void 0 ? true : _ref$hidden,
    label = _ref.label,
    target = _ref.target;
  var jumpCallback = useCallback(function () {
    if (typeof target === 'string') {
      var el = document.getElementById(target);
      if (el) {
        el.focus();
      }
    } else if (target instanceof HTMLElement) {
      target.focus();
    } else {
      if (target.current) {
        target.current.focus();
      }
    }
  }, [target]);
  return /*#__PURE__*/React.createElement(AnchorButton, {
    className: "".concat(styles.button).concat(hidden ? " ".concat(styles.hidden) : ''),
    onClick: jumpCallback
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.buttonText
  }, children ? children : label ? typeof label === 'string' ? label : /*#__PURE__*/React.createElement(I18n, {
    i18n: label
  }) : ''));
}